import { createAsyncThunk } from '@reduxjs/toolkit';
import { handleError, handleResponse, MyAxios } from '@services/SettingAxios';
import { ProductIdQueryDto } from './api.dto';
import { AnalogsProductType } from '@entities/Product/module/types/productSchema';

export const getAnaloguesByProductData = createAsyncThunk<AnalogsProductType[], ProductIdQueryDto, any>(
  'analoguesProduct/getAnaloguesByProductData',
  async query => {
    return await MyAxios.get(`/api/catalog/tyres/get-analogues-product/${query?.productId}?region=${query.regionId}`)
      .then(handleResponse)
      .catch(error => handleError(error, []));
  },
);
